'use strict';

export const toDateString = (date) => {
  const options = {
    month: `2-digit`,
    day: `2-digit`,
    year: `numeric`,
  };
  const event = new Date(date);
  const formattedDate = event.toLocaleDateString(`en-US`, options);
  return formattedDate !== `Invalid Date` ? formattedDate : date;
};

export const toDateTimeString = (date) => {
  const event = new Date(date);
  const formattedDate = event.toLocaleTimeString(`en-US`);
  return formattedDate !== `Invalid Date` ? formattedDate : date;
};



// WEBPACK FOOTER //
// ./client/services/dateTime.js